
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 15","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.85 10.359h-.89l-.495-4.102V4.029h1.867v2.228l-.482 4.102zm-1.342 2.434h1.783v-1.724H7.508v1.724zM8.441 0L0 14.565h16.88L8.441 0z","fill":"#FEF200","fill-rule":"evenodd"}})])
          )
        }
      }
    